import { useEffect, useState } from "react";
import { motion } from "framer-motion";

interface AnimatedTextProps {
  words: string[];
  className?: string;
  interval?: number;
}

export function AnimatedText({ words, className = "", interval = 2000 }: AnimatedTextProps) {
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setWordIndex((prev) => (prev + 1) % words.length);
    }, interval);
    return () => clearTimeout(timeout);
  }, [wordIndex, words, interval]);

  return (
    <span
      className={`relative inline-grid overflow-hidden align-baseline ${className}`}
      style={{ verticalAlign: "baseline", lineHeight: 1.2 }}
    >
      {words.map((word, index) => (
        <motion.span
          key={index}
          style={{ gridArea: "1 / 1", whiteSpace: "nowrap", textAlign: "left" }}
          initial={{ opacity: 0, y: "-100%" }}
          animate={
            wordIndex === index
              ? { y: "0%", opacity: 1 }
              : { y: wordIndex > index ? "100%" : "-100%", opacity: 0 }
          }
          transition={{ type: "spring", stiffness: 50 }}
        >
          {word}.
        </motion.span>
      ))}
    </span>
  );
}
